import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Doughnut } from 'react-chartjs-2';
import { Box } from 'shared/mui/Box';
import { TransactionsSuccessSummary } from 'types/embedded/dashboard';

import { useDashboardTransactionsSummaryChartData } from './hooks/useDashboardTransactionsSummaryChartData';
import { useDashboardTransactionsSummaryChartOptions } from './hooks/useDashboardTransactionsSummaryChartOptions';

type Props = {
  summary?: TransactionsSuccessSummary;
};

export const DashboardTransactionsSummaryChart: React.FC<Props> = ({ summary }) => {
  const data = useDashboardTransactionsSummaryChartData(summary);
  const options = useDashboardTransactionsSummaryChartOptions(summary);

  return (
    <Box
      sx={{
        height: '240px',
        width: '100%',
        position: 'relative',
        paddingY: '16px',
      }}
    >
      <Doughnut data={data} options={options} plugins={[ChartDataLabels]} />
    </Box>
  );
};
